import React from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils/link_helper';
import type {FaqCategoryKey} from 'app/utils/knowledgeCenter/categories';

interface Props {
    category: FaqCategoryKey
    categoryLabel: string
    articleTitle?: string
}

const KnowledgeCenterBreadcrumbs = ({
    category,
    categoryLabel,
    articleTitle
}: Props): React.ReactElement => <nav
    className="knowledge-center__crumbs"
    aria-label={I18n.t('knowledge_center.title')}
>
    <Link to={getLinkPath('/faq')}>{I18n.t('knowledge_center.title')}</Link>
    {category && <>
        <span className="knowledge-center__crumbs-sep">/</span>
        {articleTitle
            ? <Link to={getLinkPath(`/faq/category/${category}`)} className="knowledge-center__crumbs-section">
                {categoryLabel}
            </Link>
            : <span className="knowledge-center__crumbs-current">
                {categoryLabel}
            </span>}
    </>}
    {articleTitle && <>
        <span className="knowledge-center__crumbs-sep">/</span>
        <span className="knowledge-center__crumbs-current">{articleTitle}</span>
    </>}
</nav>;
export default KnowledgeCenterBreadcrumbs;
